module.exports = __webpack_public_path__ + "static/media/P1010019.e8cdfc52.jpg";